import { Box, Grid, Typography } from '@mui/material'
import React from 'react'
import { useStyles } from './styles'
import { SkuVasDetail } from './types'
import { VasRuleSku } from '../../interfaces/VasRule/VasRule'

interface ComponentProps {
  VasRuleSku: VasRuleSku | undefined
  SkuVasDetailData: SkuVasDetail | undefined
}

export const CaptureVasHeader: React.FC<ComponentProps> = ({
  SkuVasDetailData,
  VasRuleSku
}) => {
  const classes = useStyles()
  return (
    <Box className={classes.productInfoHeader}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant='caption' color='textSecondary' display='block'>
            Producto
          </Typography>
          <Typography variant='body1' style={{ fontWeight: 600 }}>
            {SkuVasDetailData?.name}
          </Typography>
        </Grid>

        <Grid item xs={6} sm={3} md={4}>
          <Typography variant='caption' color='textSecondary' display='block'>
            SKU
          </Typography>
          <Typography variant='body2'>{SkuVasDetailData?.sku}</Typography>
        </Grid>

        <Grid item xs={6} sm={3} md={4}>
          <Typography variant='caption' color='textSecondary' display='block'>
            Marca
          </Typography>
          <Typography variant='body2'>
            {VasRuleSku?.productOriginName}
          </Typography>
        </Grid>
      </Grid>
    </Box>
  )
}
